export enum MAIL_TYPE_ENUM {
  PairBooking = 1,
  Parse = 2,
  NotificationConfiguration = 3,
  ContractorAutoInvoice = 5,
  xTurTechnicalSupportMailConfiguration = 6,
  PairDocument = 7,
}
